import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import dayjs from 'dayjs'

function formatCompact(value) {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(2).replace(/\.?0+$/, '')}M`
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`
  return `${value}`
}

function formatCurrency(value) {
  const amount = Number(value) || 0
  return `NGN ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export default withTranslation()(function TargetingSummaryPanel({ t, form }) {
  const { interests, locations, ipRanges, dailyBudget, startDate, endDate } = form

  const estimatedAudience = 500000 + (interests.length * 220000) + (locations.length * 180000)
  const duration = startDate && endDate ? Math.max(1, dayjs(endDate).diff(dayjs(startDate), 'day') + 1) : null
  const totalBudget = duration ? (Number(dailyBudget) || 0) * duration : 0
  const estDailyReach = dailyBudget ? Math.round((Number(dailyBudget) || 0) / 0.02) : null

  return (
    <aside className="w-[360px] shrink-0 border-l border-border-lines px-6 py-8 overflow-y-auto">
      <div className="border border-border-lines rounded-xl p-4 mb-4">
        <p className="text-xs font-semibold tracking-wide text-secondary uppercase mb-4">{t('rewardAds.createFlow.summary.targeting_title')}</p>

        <p className="text-xs text-secondary mb-1">{t('rewardAds.createFlow.summary.estimated_audience')}</p>
        <p className="text-2xl font-bold text-dark-blue">
          {formatCompact(estimatedAudience)} <span className="text-sm font-normal text-secondary">{t('rewardAds.createFlow.summary.people')}</span>
        </p>
        <p className="text-xs text-secondary mb-4">{t('rewardAds.createFlow.summary.based_on_targeting')}</p>

        <div className="flex flex-col gap-2 text-sm border-t border-border-lines pt-3">
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.interests')}</span>
            <span className="text-dark-blue font-medium">{t('rewardAds.createFlow.summary.selected_count', { count: interests.length })}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.locations')}</span>
            <span className="text-dark-blue font-medium">{t('rewardAds.createFlow.summary.selected_count', { count: locations.length })}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.ip_ranges')}</span>
            <span className="text-dark-blue font-medium">{t('rewardAds.createFlow.summary.selected_count', { count: ipRanges.length })}</span>
          </div>
        </div>
      </div>

      <div className="border border-border-lines rounded-xl p-4 mb-4">
        <p className="text-xs font-semibold tracking-wide text-secondary uppercase mb-3">{t('rewardAds.createFlow.summary.budgeting_title')}</p>

        <div className="flex flex-col gap-2 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.daily_budget')}</span>
            <span className="text-dark-blue font-medium">{formatCurrency(dailyBudget)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.campaign_duration')}</span>
            <span className="text-dark-blue font-medium">{duration ? t('rewardAds.createFlow.summary.days_count', { count: duration }) : 'N/A'}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.total_budget')}</span>
            <span className="text-dark-blue font-medium">{formatCurrency(totalBudget)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-secondary">{t('rewardAds.createFlow.summary.est_daily_reach')}</span>
            <span className="text-dark-blue font-medium">{estDailyReach ? estDailyReach.toLocaleString() : 'N/A'}</span>
          </div>
        </div>
      </div>

      <div className="flex items-start gap-2 bg-focus rounded-xl p-3">
        <UIcons.UilInfoCircle size={16} className="text-primary shrink-0 mt-0.5" />
        <p className="text-xs text-primary">{t('rewardAds.createFlow.summary.estimate_disclaimer')}</p>
      </div>
    </aside>
  )
})
